// The "Color skills & gear by win rate" switch (prefs.showWinRates) as one reactive value, so every homepage piece that
// colors by win rate (team rows, spotlight rows, the unit-vs-team header, the unit hover) follows the team bar's chip
// at once. Luxstadio keeps it in step with prefs; other pages read the saved pref.
import { reactive } from 'vue';
import { loadPrefs } from './userPrefs.js';
import { wrColor, wrTitle, wrGap, fixedKit } from './winRateColor.js';

export const wrPref = reactive({ on: !!loadPrefs().showWinRates });

// A unit's gear, then its skillset / reaction / support / move, each tagged with its rosterStats dimension.
export function kitPieces(u) {
  const ln = (xs) => xs.filter(([, v]) => v).map(([dim, v]) => ({ dim, v }));
  return [ln([['Weapon', u.Mainhand], ['Weapon', u.Offhand], ['Head', u.Head], ['Armor', u.Armor], ['Accessory', u.Accessory]]),
    ln([['ActionSkill', u.ActionSkill], ['ReactionSkill', u.ReactionSkill], ['SupportSkill', u.SupportSkill], ['MoveSkill', u.MoveSkill]])].filter((l) => l.length);
}

// Whether a piece gets a color: the switch is on, and it isn't one spell of a fixed kit (winRateColor.fixedKit).
const on = (u, dim) => wrPref.on && !(dim === 'Ability' && fixedKit(u));
export const wrStyleFor = (u, dim, v) => { const c = on(u, dim) && wrColor(dim, v, u.Class, u.Gender); return c ? { color: c } : null; };
export const wrTipFor = (u, dim, v) => (on(u, dim) && wrTitle(dim, v, u.Class, u.Gender)) || '';

// For text-only places (the unit hover): the piece's name, then ▲/▼ and the gap when it's outside the dead zone, in
// its color, so it reads without the color too: { text: 'Auto Potion ▲2.1', color }.
export function wrSegment(u, dim, v, text = v) {
  const g = on(u, dim) ? wrGap(dim, v, u.Class, u.Gender) : null;
  return g && g.color ? { text: text + ' ' + (g.delta > 0 ? '▲' : '▼') + Math.abs(g.delta).toFixed(1), color: g.color } : { text };
}
